import * as React from "react";
import styleable from "react-styleable";
import { Link } from "react-router-dom";
import * as styles from "../../../css/components/mainlayout/BigIconButton.css"
import RightFloatingMenuItem from "./RightFloatingMenuItem";

/**
 * Big square button with icon
 * ## styleable
 * * **active** Styling for when the item is active/selected.
 * * **item** Item's base styling.
 * * **icon** Icon styling.
 *
 * @property {string} props.title - Title
 * @property {string} props.iconPath - Icon image src path
 * @property {string} props.to    - Location this item should navigate to when clicked.
 * @property {string} props.onClick - Callback when clicked.
 */
class BigIconButton extends React.Component<any, any> {

    private renderIcon() {
        return <img className={this.props.css.icon} src={this.props.iconPath} />
    }

    render() {
        let currentLocation = (window as any).reactLocation.hash.substr(1); // substr(1) to remove hash from the front of the path
        let isActiveClass = currentLocation === this.props.to ? this.props.css.active : "";

        if(this.props.to !== undefined && this.props.to !== null)
            return (
                <Link className={this.props.css.item + " " + isActiveClass} to={this.props.to} onClick={(e)=> this.props.onClick ? this.props.onClick(e) : {}}>
                    {this.renderIcon()}
                    <p>{this.props.title}</p>
                </Link>
            );
        else
            return (
                <div className={this.props.css.item + " " + isActiveClass} onClick={(e)=> this.props.onClick ? this.props.onClick(e) : {}}>
                    {this.renderIcon()}
                    <p>{this.props.title}</p>
                </div>
            );
    }
}
export default styleable(styles)(BigIconButton);